import { ONBOARDING_UI_EXPERIMENT_KEY, resolveOnboardingUIAssignment } from '@/experiments/onboardingUI';
import { initPricingMultiYearPageExperiment } from '@/experiments/pricingMultiYearPage';
import { getClientExperimentVariant } from '@/services/experiment';
import { useExperimentStore } from '@/stores/experiment';
import { useUserStore } from '@/stores/user';

let activeOnboardingUIIdentity: string | null = null;

export async function initOnboardingUIExperiment(): Promise<void> {
  const userState = useUserStore.getState();
  const currentIdentity = userState.isLogin ? userState.userInfo?.userId : null;
  activeOnboardingUIIdentity = currentIdentity ?? null;

  if (!currentIdentity) {
    useExperimentStore.getState().setOnboardingUIDecision(resolveOnboardingUIAssignment(null));
    return;
  }

  useExperimentStore.getState().setOnboardingUIDecision(resolveOnboardingUIAssignment(null));

  try {
    const response = await getClientExperimentVariant(ONBOARDING_UI_EXPERIMENT_KEY, {
      hideCodeErrorMessage: true,
      hideHTTPErrorMessage: true,
      params: { withExposure: false },
    });

    if (activeOnboardingUIIdentity !== currentIdentity) {
      return;
    }
    useExperimentStore.getState().setOnboardingUIDecision(resolveOnboardingUIAssignment(response.data));
  } catch (error) {
    console.warn('[initClientFeatures] load onboarding_ui failed:', error);
    if (activeOnboardingUIIdentity !== currentIdentity) {
      return;
    }
    useExperimentStore.getState().setOnboardingUIDecision(resolveOnboardingUIAssignment(null));
  }
}

/** 初始化仍在使用的客户端实验特性。 */
export async function initClientFeatures(): Promise<void> {
  await Promise.all([
    initOnboardingUIExperiment(),
    initPricingMultiYearPageExperiment(),
  ]);
}
